export const DASHBOARD_FETCHING = 'DASHBOARD_FETCHING';
export const DASHBOARD_FETCH_ERROR = 'DASHBOARD_FETCH_ERROR';
export const DASHBOARD_FETCH_CONFIG = 'DASHBOARD_FETCH_CONFIG';



// WEBPACK FOOTER //
// ./src/pages/home/state/dashboard/types.js